// ============================================================================
// FILE: SLAChartCategory.jsx (i18n Ready)
// ============================================================================

import React from "react";
import { useTranslation } from "react-i18next";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell
} from "recharts";

function SLAChartCategory({ data }) {
  const { t } = useTranslation();
  const items = Array.isArray(data) ? data : [];

  if (!items.length) {
    return (
      <div className="p-3 bg-white rounded-4 shadow-sm">
        {t("sla.chart.no_category", "No category data")}
      </div>
    );
  }

  const colorScale = (value) => {
    if (value <= 20) return "#4CAF50";
    if (value <= 40) return "#8BC34A";
    if (value <= 60) return "#FFC107";
    if (value <= 80) return "#FF9800";
    return "#F44336";
  };

  return (
    <div className="bg-white rounded-4 shadow-sm p-4" style={{ height: 350 }}>
      <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>
        {t("sla.charts.category", "SLA by Category")}
      </div>

      <ResponsiveContainer>
        <BarChart data={items}>
          <XAxis dataKey="category" tick={{ fontSize: 12 }} />
          <YAxis tick={{ fontSize: 12 }} unit="%" />
          <Tooltip formatter={(v) => `${v}%`} />
          <Bar dataKey="breach_percentage" name={t("sla.kpi.breach", "Breach %")}>
            {items.map((entry, idx) => (
              <Cell key={idx} fill={colorScale(entry.breach_percentage)} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default SLAChartCategory;
